import Vue from 'vue'
import Router from 'vue-router'
import { getCookies } from "@/utils/utils";
import store from "@/store/index";

Vue.use(Router)

const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/pages/home/index"),
    },
    {
      path: "/account",
      name: "account",
      component: () => import("@/pages/account/index"),
    },
    {
      path: "/land",
      name: "land",
      component: () => import("@/pages/land/index"),
    },

    {
      path: "/404",
      name: "404",
      component: () => import("@/pages/404"),
    },
    {
      path: "/loginout",
      name: "loginout",
      component: () => import("@/pages/loginout/index"),
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});

// 需要登录名单
let needLogin = ['loginout','land'];

router.beforeEach((to, from, next) => {
  // 从cookie中获取token
  let token = getCookies("token") || "";
  // 设置token到vuex
  // store.dispatch("setToken", token);
  //  没有token时遇到白名单，进入登录页面
  if (!token && needLogin.indexOf(to.name) === -1) {
    next({
      name: "loginout"
    });
  }
  // 无需登录的页面，正常进入
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js